import { DisconnectOutlined, FolderOpenOutlined } from "@/icons"
import { CommentsForm } from "@/pages/IntegrationsPage/components/molecules/CommentsForm"
import {
  ConfigItem,
  DescriptionLabelConfigItem,
  FooterConfigItem
} from "@/pages/IntegrationsPage/components/molecules/ConfigItem"
import { useIntegration } from "@/pages/IntegrationsPage/hooks/useIntegration"

import type { AzureConfigurationItemProps } from "."

export const AzureConfigurationItem = (props: AzureConfigurationItemProps) => {
  const [_, { isPending, onRemove, onReset, isDirty, t, ...rest }] =
    useIntegration(props)
  const { keyPrefix, values } = props
  const { reposCount, id } = values

  return (
    <ConfigItem
      values={values}
      Description={
        <DescriptionLabelConfigItem
          Icon={FolderOpenOutlined}
          tKey={`${keyPrefix}repos_connected`}
          count={Number(reposCount)}
        />
      }
    >
      <CommentsForm
        label={t(`${keyPrefix}enableComments`)}
        {...values}
        {...rest}
      />
      <FooterConfigItem
        formId={id}
        isDirty={isDirty}
        isPending={isPending}
        permissions={{ action: "*", resource: "*" }}
        removeTKey="general.disconnect"
        RemoveIcon={DisconnectOutlined}
        onRemove={() => onRemove(values)}
        onReset={onReset}
      />
    </ConfigItem>
  )
}
